import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "next-themes";
import { GlobalErrorBoundary, GlobalErrorProvider } from "@/components/errors/global-error";
import { setupFetchInterceptor } from "@/lib/fetch-with-auth";
import { App } from "./App";
import "./index.css";

if (import.meta.env.DEV) {
  import('react-grab');
}

// Устанавливаем глобальный интерцептор fetch для автоматического обновления токенов
setupFetchInterceptor();

const rootElement = document.getElementById("root");
if (rootElement === null) {
  throw new Error("Root element #root not found");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <GlobalErrorProvider>
      <GlobalErrorBoundary>
        <ThemeProvider
          attribute="class"
          defaultTheme="dark"
          enableSystem
          disableTransitionOnChange
        >
          <App />
        </ThemeProvider>
      </GlobalErrorBoundary>
    </GlobalErrorProvider>
  </React.StrictMode>
);
